{
    "all" : "All",
    "categoryWise" : "Category - wise",
    "filterBy" : "Filter By :",
    "report" : "Reports / ",
    "export" : "Export",
    "wing" : "Wing : ",
    "section" : "Section : ",
    "caste" : "Caste : ",
    "gender" : "Gender :",
    "reset" : "Reset",
    "moreFilter" : "More filter",
    "show" :"Show results",
    "lessFilter" : "Less filter",
    "resultAvailable" : " results available.",
    "apply" : "Apply",
    "exportReport" : "Export report",
    "exportFirstMessage" :"You will export this report, and it will be sent to all super admins.",
    "exportSecondMessage" :"If you wish to send the report to a different email, please enter the email address.",
    "noData" : "No data available.",
    "error" : "Error",
    "errorExport" : "Error in export report",
    "somethingWentWrong" : "Something went wrong.",
    "selectWing" : "Select wing",
    "selectSection" : "Select section",
    "selectClass" : "Select class",
    "selectGender" : "Select gender",
    "selectCaste" : "Select caste",
    "reportType" : "CATEGORY_WISE",
    "reportFormat" : "Excel"
}